import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Tooltip, ClickAwayListener } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import './ProgressReward.scss';

const useStyles = makeStyles ({
  root: {
    maxWidth: 456,
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 16
  },
  lastChild: {
    maxWidth: 456,
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 16,
    borderBottom: '1px solid #c1c1c1',
    padding: '0 0 43px 0',
  },
  rewardContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  rewardTitle: {
    fontSize: 20,
    color: '#10587f',
    height: 40,
    display: 'flex',
    alignItems: 'center',
    marginBottom: 0,
    fontWeight: 'bold',
  },
  rewardDesc: {
    color: '#484848',
    marginBottom: 0,
    maxWidth: 376,
  },
  rewardImage: {
    height: 40
  },
  customTooltip: {
    backgroundColor: '#094565',
    margin: '0 0 0 7px',
    padding: 8,
    maxWidth: 216,
    lineHeight: 1.2,
  },
  tooltipParagraph: {
    margin: 0,
    fontSize: 14,
    '& b': {
      fontSize: 14,
      fontWeight: 'bold'
    }
  }
});

function ProgressReward(props) {
  const {title, description, tooltip, active} = props;
  const classes = useStyles(props);

  const [open, setOpen] = useState(false);
  const handleTooltipClose = () => {
    setOpen(false);
  };
  const handleTooltipOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <div className={title !== 'Sedes' ? classes.root : classes.lastChild}>
        <div className={classes.rewardContainer}>
          <img 
            className={classes.rewardImage}
            src={active ? "/img/profile/progress/completo-sm.svg":"/img/profile/progress/desabilitado-sm.svg"}
            alt="logro"
          />
          <div style={{ marginLeft: 8 }}>
            <p className={classes.rewardTitle}>{title}</p>
            <p className={classes.rewardDesc}>
              {description}
            </p>
          </div>
        </div>
        {isMobile === true ?
          <ClickAwayListener onClickAway={handleTooltipClose}>
            <Tooltip
              onClose={handleTooltipClose}
              open={open}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              classes={{tooltip: classes.customTooltip}}
              title={
                <p className={classes.tooltipParagraph}>
                  {tooltip}
                </p>
              }
              placement='left-start'
            >
              <img
                style={{ height: 24, width: 24, marginTop: 8}}
                src="/img/profile/ayuda.png"
                alt="ayuda"
                onClick={handleTooltipOpen}
              />
            </Tooltip>
          </ClickAwayListener> :
          <Tooltip
            classes={{tooltip: classes.customTooltip}}
            title={
              <p className={classes.tooltipParagraph}>
                {tooltip}
              </p>
            }
            placement='right-start'
          >
            <img
              style={{ height: 24, width: 24, marginTop: 8}}
              src="/img/profile/ayuda.png"
              alt="ayuda"
            />
          </Tooltip>
        }
      </div>
    </>
  );
}

export default ProgressReward;
